export default {"icons":{"iconfont":"mdi"},"theme":{"themes":{"light":{},"dark":false},"options":{"variations":false}}}
